import { SplitTest } from 'Shared/services/opa/api/opaApi';
import { getActiveDecisionVariables, getSplitTestConfigs } from 'Shared/services/opa/app/splitTestService';
import { OPA_FLAG, OPA_VARIABLE } from 'Shared/services/opa/constants';
import { UserVerificationStatus , userVerificationStatuses } from 'Shared/services/ver/app/verificationService';

export interface PersonaVerificationSplitTest extends SplitTest {
  variables: {
    [OPA_VARIABLE.PERSONA_VERIFICATION_ENABLED]: boolean | null,
  }
}

/**
 * Returns the split test configuration
 */
export const personaVerificationSplitTest = (userVerificationStatus?: UserVerificationStatus | null | undefined): PersonaVerificationSplitTest => {
  if (!userVerificationStatus || userVerificationStatus !== userVerificationStatuses.mandated ) {
    return {
      enabled: false,
      variables: {
        [OPA_VARIABLE.PERSONA_VERIFICATION_ENABLED]: false,
      }
    };
  }

  const testDecision = getSplitTestConfigs([OPA_FLAG.PERSONA_VERIFICATION]);
  const variables    = getActiveDecisionVariables(OPA_FLAG.PERSONA_VERIFICATION, testDecision);

  return {
    enabled: !!variables,
    variables: {
      [OPA_VARIABLE.PERSONA_VERIFICATION_ENABLED]: variables?.[OPA_VARIABLE.PERSONA_VERIFICATION_ENABLED],
    }
  };
};